
import { Component, Prop, Vue } from 'vue-property-decorator';
import { Question } from '@/lib/Question';
@Component({})
export default class HiddenQuestion extends Vue {
    @Prop() public question?: Question;

    mounted() {
        this.question.changedEvent.emit('changed');
        this.question.validate();
    }
}
